import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import LogoutIcon from "@mui/icons-material/Logout";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from "@mui/material/styles";
import React from "react";
import kisscalLogoWithTextDarkMode from "../../public/images/KissCalLogoWithText-light.png";
import ColorModeContext from "../common/ColorModeContext";
import LanguageSelector from "../common/LanguageSelector";

/**
 * Container component for login pages
 * Manages language switching, theme toggle, and responsive layout
 * Language detection and persistence is handled by i18n.js
 */
const LoginContainer = ({ children, maxWidth = "xl", onExit, showLogoutIcon = false }) => {
    const theme = useTheme();
    const colorMode = React.useContext(ColorModeContext);

    

    return (
        (<Box
            sx={{
                minHeight: "100vh",
                bgcolor: "background.default",
                display: "flex",
                flexDirection: "column",
                color: "text.primary"
            }}>
            <AppBar>
                <Toolbar>
                    <Box
                        component="img"
                        src={kisscalLogoWithTextDarkMode}
                        alt="kisscal-logo"
                        sx={{ height: { xs: "30px", sm: "40px" }, "&:hover": { cursor: "pointer" } }}
                        onClick={() => (window.location.href = "https://kisscal.tattoo")}
                    />
                    <Box sx={{
                        flexGrow: 1
                    }}></Box>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1
                        }}>
                        <LanguageSelector />
                        <IconButton color="inherit" onClick={colorMode.toggleColorMode}>
                            {theme?.palette.mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
                        </IconButton>
                        {onExit && showLogoutIcon ? (
                            <IconButton size="large" color="inherit" onClick={onExit} aria-label="logout">
                                <LogoutIcon />
                            </IconButton>
                        ) : null}
                    </Box>
                </Toolbar>
            </AppBar>
            <Container maxWidth={maxWidth} sx={{ flex: 1, marginTop: "70px" }}>
                {children}
            </Container>
        </Box>)
    );
};

export default LoginContainer;
